import { render, staticRenderFns } from "./ReminderDetails.vue?vue&type=template&id=4c74a798&"
import script from "./ReminderDetails.vue?vue&type=script&lang=ts&"
export * from "./ReminderDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports